@if (firms().length > 1) {
  <button
    type="button"
    class="firm-pill"
    [attr.aria-expanded]="menuOpen()"
    aria-haspopup="menu"
    (click)="toggleMenu()">
    <mat-icon class="firm-pill-icon">domain</mat-icon>
    <span class="firm-pill-name">{{ selectedName() }}</span>
    <mat-icon class="firm-pill-chevron">arrow_drop_down</mat-icon>
  </button>
  @if (menuOpen()) {
    <div class="firm-menu" role="menu">
      @if (shouldShowSearch()) {
        <div class="firm-search">
          <input
            type="search"
            class="firm-search-input"
            placeholder="Search firm"
            [value]="searchTerm()"
            (input)="onSearchChange($event)">
        </div>
      }
      <div class="firm-option-list">
        @if (filteredFirms().length > 0) {
          @for (firm of filteredFirms(); track firm.firmId) {
            <button
              type="button"
              class="firm-option"
              role="menuitem"
              [class.active]="isSelected(firm.firmId)"
              [attr.aria-current]="isSelected(firm.firmId)"
              (click)="onSelect(firm.firmId)">
              <mat-icon class="firm-option-icon">domain</mat-icon>
              <span class="firm-option-copy">
                <span class="firm-option-name">{{ firm.firmName }}</span>
                @if (firmCodeLabel(firm.firmCode); as code) {
                  <small>{{ code }}</small>
                }
              </span>
            </button>
          }
        } @else {
          <div class="firm-empty">No firms found</div>
        }
      </div>
    </div>
  }
} @else if (firms().length === 1) {
  <div class="firm-pill firm-pill-static">
    <mat-icon class="firm-pill-icon">domain</mat-icon>
    <span class="firm-pill-name">{{ firms()[0].firmName }}</span>
  </div>
}
